import type { YammerI18nState } from '../../state/types';
import { getCurrentLocale } from '../locales/selectors';

import type { DateTimeFormatType } from './shared';
import { dateTimeFormatOptionsMap } from './shared';

const dateTimeFormatterCache = new Map<string, Intl.DateTimeFormat>();

export const getDateTimeFormatter = (state: YammerI18nState, formatType: DateTimeFormatType): Intl.DateTimeFormat => {
  const locale = getCurrentLocale(state);
  const cacheKey = `${locale}:${formatType}`;
  const cachedFormatter = dateTimeFormatterCache.get(cacheKey);
  if (cachedFormatter) {
    return cachedFormatter;
  }
  const formatter = new Intl.DateTimeFormat(locale, dateTimeFormatOptionsMap[formatType]);
  dateTimeFormatterCache.set(cacheKey, formatter);

  return formatter;
};
